import { frequency } from '../data/data';

export default {
    section: 'Section 8: Client Communication',
    name: 'client-communication',
    items: [
        {
            text: 'Select all methods that you use to communicate with your clients (check all that apply)',
            type: 'checkbox-list',
            name: 'communication-methods',
            props: {
                row: true,
                items: [
                    {
                        text: 'Face-to-Face Meetings',
                        value: 'face-to-face'
                    },
                    {
                        text: 'Newsletters',
                        value: 'newsletters'
                    },
                    {
                        text: 'Phone Calls',
                        value: 'phone'
                    },
                    {
                        text: 'WebEx / Skype',
                        value: 'webex-skype'
                    },
                    {
                        text: 'Emails',
                        value: 'emails'
                    },
                    {
                        text: 'Client Events',
                        value: 'client-events'
                    },
                    {
                        text: 'Birthday Cards',
                        value: 'birthday-cards'
                    },
                    {
                        text: 'Holiday Cards',
                        value: 'holiday-cards'
                    },
                    {
                        text: 'Anniversary Cards',
                        value: 'anniversary-cards'
                    },
                    {
                        text: 'Social Media',
                        value: 'social-media'
                    },
                    {
                        text: 'Other',
                        value: 'other'
                    }
                ],
                subItems: [
                    {
                        text: 'Description of other communication methods',
                        type: 'textarea',
                        name: 'communication-methods-description',
                        props: {},
                        dependencies: {
                            items: [
                                {
                                    name: 'communication-methods',
                                    operator: 'contains',
                                    value: 'other'
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            // TODO: @Cliff - The values for this may need to be calculated server side
            // and provided with the API payload for model values
            // This needs to combine all employees and owners then filter based on role
            // TODO: Which roles count as "producing" needs to be defined to create the filter
            text: 'Face-to-face client meeting frequency (exclude phone calls and WebEx meetings)',
            subItems: [
                {
                    type: 'input-label',
                    width: 12,
                    props: {
                        label: 'List the names of the producing advisors who meet face-to-face with clients',
                        tooltip: 'This is automatically filled in based on the employees or owners which have a producing role.'
                    }
                },
                {
                    type: 'data-table',
                    name: 'communication-producing-advisors',
                    props: {
                        headers: [
                            {
                                text: 'Name',
                                value: 'full-name'
                            },
                            {
                                text: 'Title',
                                value: 'title'
                            }
                        ],
                        noDataLabel: 'No producing advisors added. Please add one in the Personnel module.',
                        noCreate: true,
                        noEdit: true,
                        noDelete: true
                    }
                },
                {
                    text: 'Number of advisors',
                    type: 'text-field',
                    name: 'communication-producing-advisors-count',
                    width: 3,
                    props: {
                        readonly: true,
                        formula: {
                            name: 'count',
                            arguments: {
                                targets: [
                                    'communication-producing-advisors'
                                ]
                            }
                        }
                    }
                },
                {
                    type: 'inline',
                    props: {},
                    items: [
                        {
                            type: 'input-label',
                            width: 3,
                            props: {
                                label: ' '
                            }
                        },
                        {
                            type: 'input-label',
                            width: 3,
                            props: {
                                label: 'Frequency of Meetings'
                            }
                        },
                        {
                            type: 'input-label',
                            width: 3,
                            props: {
                                label: 'Estimated households met with during this interval'
                            }
                        },
                        {
                            type: 'input-label',
                            width: 3,
                            props: {
                                label: 'Estimated meetings per year from this interval'
                            }
                        }
                    ]
                },
                {
                    type: 'inline',
                    props: {},
                    items: [
                        {
                            type: 'input-label',
                            width: 3,
                            props: {
                                label: 'Monthly'
                            }
                        },
                        {
                            type: 'text-field',
                            name: 'communication-frequency-monthly',
                            width: 3,
                            props: {
                                format: 'percent'
                            }
                        },
                        {
                            type: 'text-field',
                            name: 'communication-frequency-monthly-interval',
                            width: 3,
                            props: {
                                readonly: true,
                                formula: {
                                    name: 'percent',
                                    arguments: {
                                        targets: [
                                            'client-total-clients',
                                            'communication-frequency-monthly'
                                        ],
                                        value: 'client-total-clients',
                                        percent: 'communication-frequency-monthly'
                                    }
                                }
                            }
                        },
                        {
                            type: 'text-field',
                            name: 'communication-frequency-monthly-yearly',
                            width: 3,
                            props: {
                                readonly: true,
                                formula: {
                                    name: 'multiply',
                                    arguments: {
                                        targets: [
                                            'communication-frequency-monthly-interval'
                                        ],
                                        values: [
                                            'communication-frequency-monthly-interval',
                                            12
                                        ]
                                    }
                                }
                            }
                        }
                    ]
                },
                {
                    type: 'inline',
                    props: {},
                    items: [
                        {
                            type: 'input-label',
                            width: 3,
                            props: {
                                label: 'Quarterly'
                            }
                        },
                        {
                            type: 'text-field',
                            name: 'communication-frequency-quarterly',
                            width: 3,
                            props: {
                                format: 'percent'
                            }
                        },
                        {
                            type: 'text-field',
                            name: 'communication-frequency-quarterly-interval',
                            width: 3,
                            props: {
                                readonly: true,
                                formula: {
                                    name: 'percent',
                                    arguments: {
                                        targets: [
                                            'client-total-clients',
                                            'communication-frequency-quarterly'
                                        ],
                                        value: 'client-total-clients',
                                        percent: 'communication-frequency-quarterly'
                                    }
                                }
                            }
                        },
                        {
                            type: 'text-field',
                            name: 'communication-frequency-quarterly-yearly',
                            width: 3,
                            props: {
                                readonly: true,
                                formula: {
                                    name: 'multiply',
                                    arguments: {
                                        targets: [
                                            'communication-frequency-quarterly-interval'
                                        ],
                                        values: [
                                            'communication-frequency-quarterly-interval',
                                            4
                                        ]
                                    }
                                }
                            }
                        }
                    ]
                },
                {
                    type: 'inline',
                    props: {},
                    items: [
                        {
                            type: 'input-label',
                            width: 3,
                            props: {
                                label: 'Tri-Annually'
                            }
                        },
                        {
                            type: 'text-field',
                            name: 'communication-frequency-triannually',
                            width: 3,
                            props: {
                                format: 'percent'
                            }
                        },
                        {
                            type: 'text-field',
                            name: 'communication-frequency-triannually-interval',
                            width: 3,
                            props: {
                                readonly: true,
                                formula: {
                                    name: 'percent',
                                    arguments: {
                                        targets: [
                                            'client-total-clients',
                                            'communication-frequency-triannually'
                                        ],
                                        value: 'client-total-clients',
                                        percent: 'communication-frequency-triannually'
                                    }
                                }
                            }
                        },
                        {
                            type: 'text-field',
                            name: 'communication-frequency-triannually-yearly',
                            width: 3,
                            props: {
                                readonly: true,
                                formula: {
                                    name: 'multiply',
                                    arguments: {
                                        targets: [
                                            'communication-frequency-triannually-interval'
                                        ],
                                        values: [
                                            'communication-frequency-triannually-interval',
                                            3
                                        ]
                                    }
                                }
                            }
                        }
                    ]
                },
                {
                    type: 'inline',
                    props: {},
                    items: [
                        {
                            type: 'input-label',
                            width: 3,
                            props: {
                                label: 'Semi-Annually'
                            }
                        },
                        {
                            type: 'text-field',
                            name: 'communication-frequency-semiannually',
                            width: 3,
                            props: {
                                format: 'percent'
                            }
                        },
                        {
                            type: 'text-field',
                            name: 'communication-frequency-semiannually-interval',
                            width: 3,
                            props: {
                                readonly: true,
                                formula: {
                                    name: 'percent',
                                    arguments: {
                                        targets: [
                                            'client-total-clients',
                                            'communication-frequency-semiannually'
                                        ],
                                        value: 'client-total-clients',
                                        percent: 'communication-frequency-semiannually'
                                    }
                                }
                            }
                        },
                        {
                            type: 'text-field',
                            name: 'communication-frequency-semiannually-yearly',
                            width: 3,
                            props: {
                                readonly: true,
                                formula: {
                                    name: 'multiply',
                                    arguments: {
                                        targets: [
                                            'communication-frequency-semiannually-interval'
                                        ],
                                        values: [
                                            'communication-frequency-semiannually-interval',
                                            2,
                                        ]
                                    }
                                }
                            }
                        }
                    ]
                },
                {
                    type: 'inline',
                    props: {},
                    items: [
                        {
                            type: 'input-label',
                            width: 3,
                            props: {
                                label: 'Annually'
                            }
                        },
                        {
                            type: 'text-field',
                            name: 'communication-frequency-annually',
                            width: 3,
                            props: {
                                format: 'percent'
                            }
                        },
                        {
                            type: 'text-field',
                            name: 'communication-frequency-annually-interval',
                            width: 3,
                            props: {
                                readonly: true,
                                formula: {
                                    name: 'percent',
                                    arguments: {
                                        targets: [
                                            'client-total-clients',
                                            'communication-frequency-annually'
                                        ],
                                        value: 'client-total-clients',
                                        percent: 'communication-frequency-annually'
                                    }
                                }
                            }
                        },
                        {
                            type: 'text-field',
                            name: 'communication-frequency-annually-yearly',
                            width: 3,
                            props: {
                                readonly: true,
                                formula: {
                                    name: 'multiply',
                                    arguments: {
                                        targets: [
                                            'communication-frequency-annually-interval'
                                        ],
                                        values: [
                                            'communication-frequency-annually-interval',
                                            1
                                        ]
                                    }
                                }
                            }
                        }
                    ]
                },
                {
                    type: 'inline',
                    props: {},
                    items: [
                        {
                            type: 'input-label',
                            width: 3,
                            props: {
                                label: 'Less than Annually'
                            }
                        },
                        {
                            type: 'text-field',
                            name: 'communication-frequency-lessthanannually',
                            width: 3,
                            props: {
                                format: 'percent'
                            }
                        },
                        {
                            type: 'text-field',
                            name: 'communication-frequency-lessthanannually-interval',
                            width: 3,
                            props: {
                                readonly: true,
                                formula: {
                                    name: 'percent',
                                    arguments: {
                                        targets: [
                                            'client-total-clients',
                                            'communication-frequency-lessthanannually'
                                        ],
                                        value: 'client-total-clients',
                                        percent: 'communication-frequency-lessthanannually'
                                    }
                                }
                            }
                        },
                        {
                            type: 'text-field',
                            name: 'communication-frequency-lessthanannually-yearly',
                            width: 3,
                            props: {
                                readonly: true,
                                formula: {
                                    name: 'multiply',
                                    arguments: {
                                        targets: [
                                            'communication-frequency-lessthanannually-interval'
                                        ],
                                        values: [
                                            'communication-frequency-lessthanannually-interval',
                                            0.5
                                        ]
                                    }
                                }
                            }
                        }
                    ]
                },
                {
                    type: 'inline',
                    props: {},
                    items: [
                        {
                            type: 'input-label',
                            width: 3,
                            props: {
                                label: ' '
                            }
                        },
                        {
                            type: 'text-field',
                            name: 'communication-frequency-total',
                            width: 3,
                            props: {
                                format: 'percent',
                                tooltip: 'This value is calculated from the fields above.  It should equal 100%.',
                                formula: {
                                    name: 'sum',
                                    arguments: {
                                        targets: [
                                            'communication-frequency-monthly',
                                            'communication-frequency-quarterly',
                                            'communication-frequency-semiannually',
                                            'communication-frequency-annually',
                                            'communication-frequency-lessthanannually'
                                        ]
                                    }
                                }
                            }
                        },
                        {
                            type: 'input-label',
                            width: 3,
                            props: {
                                label: ' '
                            }
                        },
                        {
                            type: 'input-label',
                            width: 3,
                            props: {
                                label: ' '
                            }
                        }
                    ]
                },
                {
                    type: 'inline',
                    props: {},
                    items: [
                        {
                            type: 'input-label',
                            width: 3,
                            props: {
                                label: ' '
                            }
                        },
                        {
                            type: 'input-label',
                            width: 3,
                            props: {
                                label: 'Totals Per Year'
                            }
                        },
                        {
                            type: 'text-field',
                            name: 'communication-frequency-interval-total',
                            width: 3,
                            props: {
                                formula: {
                                    name: 'sum',
                                    arguments: {
                                        targets: [
                                            'communication-frequency-monthly-interval',
                                            'communication-frequency-quarterly-interval',
                                            'communication-frequency-semiannually-interval',
                                            'communication-frequency-annually-interval',
                                            'communication-frequency-lessthanannually-interval'
                                        ]
                                    }
                                }
                            }
                        },
                        {
                            type: 'text-field',
                            name: 'communication-frequency-yearly-total',
                            width: 3,
                            props: {
                                formula: {
                                    name: 'sum',
                                    arguments: {
                                        targets: [
                                            'communication-frequency-monthly-yearly',
                                            'communication-frequency-quarterly-yearly',
                                            'communication-frequency-semiannually-yearly',
                                            'communication-frequency-annually-yearly',
                                            'communication-frequency-lessthanannually-yearly'
                                        ]
                                    }
                                }
                            }
                        }
                    ]
                },
                {
                    type: 'inline',
                    props: {},
                    items: [
                        {
                            type: 'input-label',
                            width: 3,
                            props: {
                                label: ' '
                            }
                        },
                        {
                            type: 'input-label',
                            width: 3,
                            props: {
                                label: ' '
                            }
                        },
                        {
                            type: 'input-label',
                            width: 3,
                            props: {
                                label: 'Estimated Meetings per Week'
                            }
                        },
                        {
                            type: 'text-field',
                            name: 'communication-frequency-weekly-total',
                            width: 3,
                            props: {
                                formula: {
                                    name: 'divide',
                                    arguments: {
                                        targets: [
                                            'communication-frequency-yearly-total'
                                        ],
                                        values: [
                                            'communication-frequency-yearly-total',
                                            52
                                        ]
                                    }
                                }
                            }
                        }
                    ]
                },
                {
                    type: 'inline',
                    props: {},
                    items: [
                        {
                            type: 'input-label',
                            width: 3,
                            props: {
                                label: ' '
                            }
                        },
                        {
                            type: 'input-label',
                            width: 3,
                            props: {
                                label: ' '
                            }
                        },
                        {
                            type: 'input-label',
                            width: 3,
                            props: {
                                label: 'Estimated meetings per advisor per week'
                            }
                        },
                        {
                            type: 'text-field',
                            name: 'communication-frequency-per-advisor-total',
                            width: 3,
                            props: {
                                formula: {
                                    name: 'divide',
                                    arguments: {
                                        targets: [
                                            'communication-frequency-weekly-total'
                                        ],
                                        values: [
                                            'communication-frequency-weekly-total',
                                            'communication-producing-advisors-count'
                                        ]
                                    }
                                }
                            }
                        },
                    ]
                }
            ]
        },
        {
            text: 'Estimate the frequency of ALL forms of client communication (telephone calls, newsletters, face-to-face, etc)',
            subItems: [
                {
                    text: 'Top Quartile',
                    type: 'selectlist',
                    name: 'communication-frequency-top-quartile',
                    props: {
                        items: frequency
                    }
                },
                {
                    text: '2nd Quartile',
                    type: 'selectlist',
                    name: 'communication-frequency-second-quartile',
                    props: {
                        items: frequency
                    }
                },
                {
                    text: '3rd Quartile',
                    type: 'selectlist',
                    name: 'communication-frequency-third-quartile',
                    props: {
                        items: frequency
                    }
                },
                {
                    text: 'Bottom Quartile',
                    type: 'selectlist',
                    name: 'communication-frequency-bottom-quartile',
                    props: {
                        items: frequency
                    }
                },
                {
                    type: 'frequency-chart',
                    name: 'communication-frequency',
                    props: {}
                }
            ]
        },
        {
            text: 'Where do you meet with clients face-to-face?',
            subItems: [
                {
                    text: 'Primary Office',
                    type: 'text-field',
                    name: 'communication-face-to-face-primary-office',
                    width: 3,
                    props: {
                        format: 'percent'
                    }
                },
                {
                    text: 'Secondary Office',
                    type: 'text-field',
                    name: 'communication-face-to-face-secondary-office',
                    width: 3,
                    props: {
                        format: 'percent'
                    }
                },
                {
                    text: 'Client\'s Home',
                    type: 'text-field',
                    name: 'communication-face-to-face-client-home',
                    width: 3,
                    props: {
                        format: 'percent'
                    }
                },
                {
                    text: 'Client\'s Office',
                    type: 'text-field',
                    name: 'communication-face-to-face-client-office',
                    width: 3,
                    props: {
                        format: 'percent'
                    }
                },
                {
                    text: 'Other (restaurants, coffee shops, country clubs, etc.)',
                    type: 'text-field',
                    name: 'communication-face-to-face-other',
                    width: 3,
                    props: {
                        format: 'percent'
                    }
                },
            ]
        },
        {
            text: 'What percentage of your formal review meetings are by phone?',
            type: 'text-field',
            name: 'communication-phone',
            width: 3,
            props: {
                format: 'percent'
            }
        },
        {
            text: 'What percentage of your formal review meetings are by WebEx/Skype/Etc.?',
            type: 'text-field',
            name: 'communication-web',
            width: 3,
            props: {
                format: 'percent'
            }
        }
    ]
}


// WEBPACK FOOTER //
// ./src/components/valuation/valuation-data/client-communication.js